
import AnimateOverSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/animate-over-symbol-behaviour";
import Contract from "slotworks/utils/contract";

export default class SGFrameSymbolBehaviour extends AnimateOverSymbolBehaviour {

    public behaviourName: string = "Frame";

    public highlight(): Contract<void> {
        // Remove highlight as the normal over will suffice for that
        return this.animate("_frame", [this.defaultAnimation]);
    }

    public win(): Contract<void> {
        return this.animate("_frame", [this.defaultAnimation], false, true);
    }

    public cycle(): Contract<void> {
        return this.animate("_frame", [this.defaultAnimation], false, true);
    }
}
